import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    intervalTime: 5000, //盘口自动获取时间
	menuchar: false, //走势图导航
    windowWidth: 0,    //当前屏幕宽度
    search: '',     
    lottoDetailName: '',
    lottoType: '',
    lottoList: [
    
    {name:'btb1fpk',img:'btb1fpk-img',nickname:'比特币1分赛车',type:'pk',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'btb3fpk',img:'btb3fpk-img',nickname:'比特币3分赛车',type:'pk',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:1,allCount: '',todayCount:''},
    {name:'btbpc28',img:'btbpc28-img',nickname:'比特币PC28',type:'pc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:1,allCount: '',todayCount:''},
     {name:'cqssc',img:'cqssc-img',nickname:'比特币1分彩',type:'ssc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'bjpk',img:'bjpk-img',nickname:'北京赛车',type:'pk',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'xyft',img:'xyft-img',nickname:'幸运飞艇',type:'pk',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'pcbj',img:'pcbj-img',nickname:'北京PC28',type:'pc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:1,allCount: '',todayCount:''},
    {name:'pctx',img:'pcbj-img',nickname:'腾讯PC28',type:'pc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:1,allCount: '',todayCount:''},
    {name:'pcjnd',img:'pcjnd-img',nickname:'加拿大PC28',type:'pc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'pccq',img:'pccq-img',nickname:'重庆PC28',type:'pc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:1,allCount: '',todayCount:''},
    {name:'pcxj',img:'pcxj-img',nickname:'新疆PC28',type:'pc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'jndx',img:'jndx-img',nickname:'加拿大西PC28',type:'pc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'slfk',img:'slfk-img',nickname:'斯洛伐克PC28',type:'pc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'twbg',img:'twbg-img',nickname:'台湾宾果PC28',type:'pc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'elg',img:'elg-img',nickname:'俄勒冈PC28',type:'pc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'gdklsf',img:'gdklsf-img',nickname:'广东快乐十分',type:'m8',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'xync',img:'xync-img',nickname:'幸运农场',type:'m8',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'tjklsf',img:'tjklsf-img',nickname:'天津快乐十分',type:'m8',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'hnklsf',img:'hnklsf-img',nickname:'湖南快乐十分',type:'m8',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'ynklsf',img:'ynklsf-img',nickname:'云南快乐十分',type:'m8',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'cqssc',img:'cqssc-img',nickname:'重庆时时彩',type:'ssc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:1,allCount: '',todayCount:''},
    {name:'xjssc',img:'xjssc-img',nickname:'新疆时时彩',type:'ssc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:1,allCount: '',todayCount:''},
    {name:'txssc',img:'txssc-img',nickname:'腾讯时时彩',type:'ssc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:1,allCount: '',todayCount:''},
    {name:'tjssc',img:'tjssc-img',nickname:'天津时时彩',type:'ssc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:1,allCount: '',todayCount:''},
    {name:'ynssc',img:'ynssc-img',nickname:'云南时时彩',type:'ssc',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:1,allCount: '',todayCount:''},
    {name:'jsk3',img:'jsk3-img',nickname:'江苏快3',type:'k3',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'jlk3',img:'jlk3-img',nickname:'吉林快3',type:'k3',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'hlk3',img:'hlk3-img',nickname:'河北快3',type:'k3',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:0,allCount: '',todayCount:''},
    {name:'ahk3',img:'ahk3-img',nickname:'安微快3',type:'k3',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:1,allCount: '',todayCount:''},
    {name:'lhc',img:'lhc-img',nickname:'香港彩',type:'LHC',endTime:0,nums:'',curIssue:'??????',nextIssue:'??????',status:1,allCount: '',todayCount:''},
],
    isSound: true,
    soundName: 'RING_01',
}
const mutations={
        charshow(){
            state.menuchar = true;
        },
        charhide(){
        	state.menuchar = false;
        },
        setWindowWidth(state, n){
            state.windowWidth = n;
        },
        setSearch(state, n){
            state.search = n;
        },
        setLottoDetailName(state, n){
            state.lottoDetailName = n;
        },
        setLottoType(state, n){
            state.lottoType = n;
        },
        setIsSound(state, n){
            state.isSound = n;
        },
        setSoundName(state, n){
            state.soundName = n;
        }
    }

export default new Vuex.Store({
	state,
	mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js